export class EventConstants {
  public static readonly StateChanged: string = "state-update";
  public static readonly NameChanged: string = "name-changed";
  public static readonly ConnectionIdAssigned: string = "connection-id-assigned";
}
